import gsap from "gsap";
import NotifStack from "../../utils/NotifStack";

const GAP = 12;

export default class ModalProductPush {
  constructor(el) {
    this.el = el;
    this.closeBtn = el.querySelector(".c-modal-product-push__close");

    NotifStack.register(this.el, { delay: 0.1 });
    this.closeBtn?.addEventListener("click", () => NotifStack.dismiss(this.el));

    // Sticky mode: CSS `position: sticky` (see [data-sticky-within] in
    // _modal-product-push.scss) handles the visuals on its own — it un-sticks
    // and scrolls away with the hero natively, no position/right toggling
    // needed here. But NotifStack has no way to know that just happened, so
    // without the tracking below it keeps reserving this card's slot forever,
    // leaving a permanent gap above it once it's scrolled out of view.
    this.isStickyWithin = Boolean(el.dataset.stickyWithin);

    this.hero = el.closest(".c-homepage-hero");
    this._isOut = false;
    this._stackBottom = GAP;

    if (this.hero) {
      this._onScroll = this._update.bind(this);
      window.addEventListener("scroll", this._onScroll, { passive: true });
      this._update();
    }
  }

  _update() {
    const heroBottom = this.hero.getBoundingClientRect().bottom;

    if (!this._isOut) {
      // Our current fixed-stack position — NotifStack has already placed us
      // above whatever else is registered (vs-privacy, lifetime-sticky-push,
      // or nothing) — captured now, before we possibly leave the stack below.
      this._stackBottom = parseFloat(gsap.getProperty(this.el, "bottom")) || GAP;

      if (heroBottom <= window.innerHeight - this._stackBottom + GAP) {
        this._isOut = true;
        // Leaves the fixed bottom-right stack entirely: whatever else is
        // registered closes the gap and drops down, since there's nothing
        // fixed below this until the hero scrolls back into view.
        NotifStack.unregister(this.el);

        if (!this.isStickyWithin) {
          this.el.style.position = "absolute";
          gsap.set(this.el, { bottom: GAP });
          this._syncRight();
        }
      }
    } else if (heroBottom > window.innerHeight - this._stackBottom + GAP) {
      this._isOut = false;

      if (!this.isStickyWithin) {
        this.el.style.position = "fixed";
      }
      // Rejoins the stack at its original slot (NotifStack keeps a stable
      // order per element), pushing whatever's above it back up — snaps back
      // in rather than replaying the slide-in-from-the-right.
      NotifStack.register(this.el, { skipEntrance: true });
    } else if (!this.isStickyWithin) {
      this._syncRight();
    }
  }

  _syncRight() {
    // The hero insets itself through clip-path (see homepage-hero.js): follow
    // its right inset so the push stays inside the visible edge.
    const clip = String(gsap.getProperty(this.hero, "clipPath"));
    const heroInsetRight = parseFloat(clip.match(/inset\(\s*[\d.]+px\s+([\d.]+)px/)?.[1]) || 0;
    gsap.set(this.el, { right: GAP + heroInsetRight });
  }
}
